import { render, staticRenderFns } from "./DoctorCreateEditModal.vue?vue&type=template&id=72a962fb&"
import script from "./DoctorCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./DoctorCreateEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorCreateEditModal.vue?vue&type=style&index=0&id=72a962fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports